var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.presets),function(preset,i){return _c('div',{key:i,staticClass:"breakdance-presets-in-design-tab-preset",on:{"click":function($event){return _vm.applyPreset(preset)}}},[_vm._v(" "+_vm._s(preset.label)+" "),_c('img',{attrs:{"src":preset.screenshotUrl.url}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }